import * as querystring from 'querystring';


/**
 * Parses a query string into the specified type for convenient access to the props.
 * Note that, as this method's name implies, all parameters will be parsed as string keys with string values (or with
 * value undefined, in the event that they're missing from the query string). Non-string props will not be re-cast.
 *
 * @param query
 */
export const parseQueryToKeyedStrings = <T extends {}>(query: string): T => {
  // Remove leading question mark
  const scrubbed = query.startsWith('?') ? query.substr(1) : query;
  const queryObj = querystring.parse(scrubbed);
  return queryObj as typeof queryObj as T;
};
